import React, { useState } from '@wordpress/element';
import { BrowserRouter } from 'react-router-dom';
import StoreProvider from '../../store/store-provider';
import ArchiveList from '../../UI/archive-list';
import PortalProvider from '../../portal-provider';
import ListMap from '../../UI/list-map';
import { findBlockByName } from '../../helpers/blockHelpers';

export const getImages = postItem => {
    if (!postItem || !postItem.blocks) {
        return null;
    }

    //Find first occurance of image gallery block
    const imageGallery = findBlockByName('dalslandskanal-custom-blocks/image-gallery', postItem.blocks);
    const imageCarousel = findBlockByName('dalslandskanal-custom-blocks/image-slider', postItem.blocks);
    
    if (imageGallery) {
        return imageGallery.attrs.images;
    }

    if(imageCarousel) {
        return imageCarousel.attrs.images;
    }

    return null;
}

export const getListprice = postItem => {
    if (!postItem || !postItem.blocks) {
        return null;
    }

    //Find first occurance of booking block
    const bookingBlock = findBlockByName('dalslandskanal-custom-blocks/booking', postItem.blocks);
    if (!bookingBlock) {
        return null;
    }

    return bookingBlock.attrs.listPrice;
};

export const getFactsText = postItem => {
    if (!postItem || !postItem.blocks) {
        return null;
    }

    //Find first occurance of booking block
    const factsBlock = findBlockByName('dalslandskanal-custom-blocks/facts', postItem.blocks);
    if (!factsBlock) {
        return null;
    }

    return factsBlock.attrs.factsInLists;  
};

const AccommodationsLayout = props => {
    const [hoverId, setHoverId] = useState(null);

    return (
        <>
            <ArchiveList {...props} hoverHandler={setHoverId} getImages={(post) => getImages(post)} getFactsText={(post) => <span className="card__facts">{getFactsText(post)}</span>} getAltFacts={(post) => <span className="card__altfacts">{getListprice(post)}</span>}  />
            <PortalProvider elementId="map-list-root">
                <ListMap {...props} hoverId={hoverId} />
            </PortalProvider>
        </>
    );
};


const Accommodations = props => {
    return (
        <BrowserRouter>
            <StoreProvider {...props} type="accommodation" perPage="10">
                <AccommodationsLayout />
            </StoreProvider>
        </BrowserRouter>
    );
};

export default Accommodations;